export default {
  'talk.title': 'общая группа',
  'talk.btn.add': 'Добавить группу',
  'talk.btn.guard': 'загрузчик',
  'talk.table.name': 'название группы',
  'talk.input.name': 'Пожалуйста, введите название разговорной группы',
  'talk.download.nodata':
    'Нет информации об устройстве для загрузки, сначала введите устройство, а затем загрузите данные',
};
